<app-window-title [closable]="true"
                  [title]="title"
                  (closed)="dialogRef.close()"></app-window-title>

<div class="search-dialog-content fx-col"  mat-dialog-content>
  <!-- SEARCH INPUT -->
  <div class="search-section fx-row fx-jc-center fx-ai-center"  >
    <mat-form-field appearance="outline"  class="fx-flex-90">
      <mat-label>
        Search {{Labels.clientMatterLabel}}
      </mat-label>
      <input #searchClientsInput
             placeholder="by name, medical record number or date of birth"

             cdkFocusInitial
             matInput
             [value]="caseName"

             (input)="caseName = searchClientsInput.value"
             (keyup)="search($event)">
    </mat-form-field>
    <button color="warn"
            mat-icon-button
            matTooltip="Search"
            (click)="search($event)">
      <mat-icon>
        search
      </mat-icon>
    </button>
    <button color="warn"
            mat-icon-button
            matTooltip="Refresh"
            (click)="getFilesSharedWith()">
      <mat-icon>
        refresh
      </mat-icon>
    </button>
  </div>

  <!-- SEARCH CRITERIA INFO -->
  <div *ngIf="!ownerNeeded"
       class="search-info">
    <small>
      You can search by: 'first name', 'last name', 'Patient ID' and 'Date of birth'
    </small>
  </div>

  <!-- SPOKE — NO HUB RELATIONSHIP WARNING -->
  <div *ngIf="isSpoke && noHubRelationship"
       class="no-hub-banner">
    <mat-icon class="no-hub-icon">link_off</mat-icon>
    <div class="no-hub-text">
      <strong>No Hub connected yet</strong>
      <p>
        Your facility is not yet part of a Hub network. Patients shared by a Hub will appear here once a Hub sends images to your facility.
        Contact your Hub administrator to get started.
      </p>
    </div>
  </div>

  <!-- NO RESULTS -->
  <div *ngIf="!ownerNeeded && !searchResult?.length && !noHubRelationship"
       class="no-results fx-jc-center fx-ai-center"  >
    <p>
      No patients found
    </p>
  </div>

  <!-- RESULTS -->
  <div *ngIf="searchResult?.length > 0"
       class="results-section">
    <div class="results-header fx-row fx-jc-start fx-ai-center"  >
      <mat-icon class="results-icon">
        people
      </mat-icon>
      <span class="results-count">
        <strong>
          {{searchResult.length}}
        </strong>
        {{searchResult.length === 1 ? 'patient' : 'patients'}} found
      </span>
    </div>

    <div class="results-list">
      <div *ngFor="let patient of searchResult; trackBy: trackByClientId"
           class="client-item"
           (click)="dialogdata ? handleSelectClient(patient) : routeToProfile(patient)">
        <app-client-list-item [client]="patient"
                              [hasNotifications]="patient.hasNotifications"
                              [permissions]="{dialogdata: false, ableToEditClient: ableToEditClient}"
                              (editClient)="editClient($event)">
        </app-client-list-item>
      </div>
    </div>
  </div>
</div>
